export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'fa fa-dashboard',
      badge: {
        variant: 'primary'
      }
    },
    {
      name: 'Intraday Report',
      url: '/intraday',
      icon: 'fa fa-dashboard',
    },
    {
      name: 'Reports',
      url: '/#',
      icon: 'fa fa-bar-chart',
      children: [
        {
          name: 'Reports',
          url: '/reports',
          icon: 'fa fa-bar-chart'
        },
        {
          name: 'Monthly Report',
          url: '/monthly_report',
          icon: 'fa fa-bar-chart'
        },
        {
          name: 'Discrepancy Report',
          url: '/discrepancy_report',
          icon: 'fa fa-rocket'
        },
        {
          name: 'Tickets Missing Hauls',
          url: '/receipts_wo_hauls',
          icon: 'fa fa-rocket'
        },
        {
          name: 'Altex Ticket Check',
          url: '/altex_check',
          icon: 'fa fa-rocket'
        },
        {
          name: 'Petrotranz Report',
          url: '/petrotranz_report',
          icon: 'fa fa-rocket'
        }
      ]
    },
    {
      name: 'Hauls',
      url: '/#',
      icon: 'fa fa-rocket',
      children: [
        {
          name: 'All Hauls',
          url: '/hauls',
          icon: 'fa fa-rocket'
        },
        {
          name: 'Duplicate Hauls',
          url: '/duplicated_hauls',
          icon: 'fa fa-rocket'
        }
      ]
    },
    {
      name: 'Request Hauls',
      url: '/request_hauls',
      icon: 'fa fa-rocket'
    },
    {
      name: 'Invoices',
      url: '/#',
      icon: 'fa fa-rocket',
      children: [
        {
          name: 'Trucking Company Invoices',
          url: '/invoices',
          icon: 'fa fa-rocket'
        },
        {
          name: 'Haul Invoices',
          url: '/invoices_hauls',
          icon: 'fa fa-rocket'
        },
        {
          name: 'Customer',
          url: '/invoice_customers',
          icon: 'fa fa-rocket'
        },
        {
          name: 'Contract',
          url: '/invoice_contracts',
          icon: 'fa fa-rocket'
        },
        {
          name: 'Adjust',
          url: '/invoice_adjusts',
          icon: 'fa fa-rocket'
        },
        {
          name: 'Price',
          url: '/invoice_prices',
          icon: 'fa fa-rocket'
        }
      ]
    },
    {
      name: 'Nominations',
      url: '/targets',
      icon: 'fa fa-bullseye'
    },
    {
      name: 'Energy Companies',
      url: '/energy_companies',
      icon: 'fa fa-building'
    },
    {
      name: 'Trucking',
      url: '/#',
      icon: 'fa fa-truck',
      children: [
        {
          name: 'Companies',
          url: '/trucking_companies',
          icon: 'fa fa-building'
        },
        {
          name: 'Trailers',
          url: '/trucks',
          icon: 'fa fa-truck'
        },
        {
          name: 'Truck Units',
          url: '/trucks_units',
          icon: 'fa fa-truck'
        },
        {
          name: 'Agreements',
          url: '/agreements',
          icon: 'icon-docs'
        },
        {
          name: 'Hauls Without Agreements',
          url: '/agreements_pending',
          icon: 'icon-docs'
        }
      ]
    },
    {
      name: 'Users',
      url: '/users',
      icon: 'icon-people'
    },
    {
      name: 'Locations',
      url: '/#',
      icon: 'icon-location-pin',
      children: [
        {
          name: 'Load and Unload Locations',
          url: '/locations',
          icon: 'fa fa-map-marker'
        },
        {
          name: 'Operating Areas',
          url: '/operating_areas',
          icon: 'fa fa-industry'
        }
      ]
    },
    {
      name: 'Terminal',
      url: '/#',
      icon: 'icon-location-pin',
      children: [
        {
          name: 'Terminals',
          url: '/terminals',
          icon: 'fa fa-map-marker'
        },
        {
          name: 'Terminal Companies',
          url: '/terminal_companies',
          icon: 'fa fa-map-marker'
        },
        {
          name: 'Terminal Agreements',
          url: '/terminal_agreements',
          icon: 'fa fa-list'
        },
        {
          name: 'Pending Terminal Agreements',
          url: '/terminal_agreements_pending',
          icon: 'fa fa-list'
        },
        {
          name: 'Indexes',
          url: '/indexes',
          icon: 'fa fa-list'
        },
        {
          name: 'WTI',
          url: '/wti',
          icon: 'fa fa-list'
        }
      ]
    },
    {
      divider: true
    },
    {
      name: 'Setting',
      url: '/#',
      icon: 'fa fa-cogs',
      children: [
        {
          name: 'Isolera',
          url: '/update_volume_estimate',
          icon: 'fa fa-pencil',
        },
        {
          name: 'Hazards',
          url: '/hazards',
          icon: 'fa fa-tint'
        },
        {
          name: 'Controls',
          url: '/controls',
          icon: 'fa fa-tint'
        },
        {
          name: 'TDG',
          url: '/tdgs',
          icon: 'fa fa-tint'
        },
        {
          name: 'Reports',
          url: '/powerbi',
          icon: 'fa fa-tint'
        },
        {
          name: 'Notification',
          url: '/notification',
          icon: 'fa fa-tint'
        },
        {
          name: 'Request Haul Notifications',
          url: '/request_haul_notifications',
          icon: 'fa fa-tint'
        },
        {
          name: 'Invoice Notifications',
          url: '/invoice_haul_notifications',
          icon: 'fa fa-tint'
        },
        {
          name: 'Folders',
          url: '/folders',
          icon: 'fa fa-folder'
        },
        {
          name: 'Fluid Types',
          url: '/fluid_types',
          icon: 'fa fa-tint'
        },
        {
          name: 'Truck Types',
          url: '/truck_types',
          icon: 'fa fa-truck'
        },
        {
          name: 'Location Types',
          url: '/location_types',
          icon: 'fa fa-location-arrow'
        },
        {
          name: 'Roles',
          url: '/roles',
          icon: 'fa fa-user-circle'
        },
        {
          name: 'Services',
          url: '/services',
          icon: 'fa fa-handshake-o'
        },
        {
          name: 'API-Keys',
          url: '/keys',
          icon: 'fa fa-handshake-o'
        },
        {
          name: 'Fail Logs',
          url: '/logs',
          icon: 'fa fa-pencil'
        },
        {
          name: 'Other',
          url: '/#',
          icon: 'fa fa-pencil',
          children: [
            {
              name: 'Export to PVR',
              url: '/other',
              icon: 'fa fa-folder'
            }
          ]
        }
      ]
    }
  ],
  items_super_analyst: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'fa fa-dashboard',
      badge: {
        variant: 'primary'
      }
    },
    {
      name: 'Reports',
      url: '/#',
      icon: 'fa fa-bar-chart',
      children: [
        {
          name: 'Reports',
          url: '/reports',
          icon: 'fa fa-bar-chart'
        },
        {
          name: 'Monthly Report',
          url: '/monthly_report',
          icon: 'fa fa-bar-chart'
        }
      ]
    },
    {
      name: 'Hauls',
      url: '/#',
      icon: 'fa fa-rocket',
      children: [
        {
          name: 'All Hauls',
          url: '/hauls',
          icon: 'fa fa-rocket'
        },
        {
          name: 'Duplicate Hauls',
          url: '/duplicated_hauls',
          icon: 'fa fa-rocket'
        }
      ]
    },
    {
      name: 'Request Hauls',
      url: '/request_hauls',
      icon: 'fa fa-rocket'
    },
    {
      name: 'Nominations',
      url: '/targets',
      icon: 'fa fa-bullseye'
    },
    {
      name: 'Agreements',
      url: '/agreements',
      icon: 'icon-docs'
    },
    {
      name: 'Hauls Without Agreements',
      url: '/agreements_pending',
      icon: 'icon-docs'
    },
    {
      name: 'Users',
      url: '/users',
      icon: 'icon-people'
    },
    {
      name: 'Locations',
      url: '/#',
      icon: 'icon-location-pin',
      children: [
        {
          name: 'Load and Unload Locations',
          url: '/locations',
          icon: 'icon-location-pin'
        },
        {
          name: 'Operating Areas',
          url: '/operating_areas',
          icon: 'fa fa-map-marker'
        },
        {
          name: 'Terminal Agreements',
          url: '/terminal_agreements',
          icon: 'fa fa-list'
        }
      ]
    },
    {
      divider: true
    },
    {
      name: 'Setting',
      url: '/#',
      icon: 'fa fa-cogs',
      children: [
        {
          name: 'Notification',
          url: '/notification',
          icon: 'fa fa-tint'
        },
        {
          name: 'Folders',
          url: '/folders',
          icon: 'fa fa-tint'
        },
        {
          name: 'Other',
          url: '/#',
          icon: 'fa fa-pencil',
          children: [
            {
              name: 'Export to PRV',
              url: '/other',
              icon: 'fa fa-folder'
            }
          ]
        }
      ]
    }
  ],
  items_super_analyst_ser: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'fa fa-dashboard',
      badge: {
        variant: 'primary'
      }
    },
    {
      name: 'Intraday Report',
      url: '/intraday',
      icon: 'fa fa-dashboard',
    },
    {
      name: 'Reports',
      url: '/#',
      icon: 'fa fa-bar-chart',
      children: [
        {
          name: 'Reports',
          url: '/reports',
          icon: 'fa fa-bar-chart'
        },
        {
          name: 'Monthly Report',
          url: '/monthly_report',
          icon: 'fa fa-bar-chart'
        }
      ]
    },
    {
      name: 'Hauls',
      url: '/#',
      icon: 'fa fa-rocket',
      children: [
        {
          name: 'All Hauls',
          url: '/hauls',
          icon: 'fa fa-rocket'
        },
        {
          name: 'Duplicate Hauls',
          url: '/duplicated_hauls',
          icon: 'fa fa-rocket'
        }
      ]
    },
    {
      name: 'Request Hauls',
      url: '/request_hauls',
      icon: 'fa fa-rocket'
    },
    {
      name: 'Nominations',
      url: '/targets',
      icon: 'fa fa-bullseye'
    },
    {
      name: 'Agreements',
      url: '/agreements',
      icon: 'icon-docs'
    },
    {
      name: 'Hauls Without Agreements',
      url: '/agreements_pending',
      icon: 'icon-docs'
    },
    {
      name: 'Users',
      url: '/users',
      icon: 'icon-people'
    },
    {
      name: 'Locations',
      url: '/#',
      icon: 'icon-location-pin',
      children: [
        {
          name: 'Load and Unload Locations',
          url: '/locations',
          icon: 'icon-location-pin'
        },
        {
          name: 'Operating Areas',
          url: '/operating_areas',
          icon: 'fa fa-map-marker'
        },
        {
          name: 'Terminal Agreements',
          url: '/terminal_agreements',
          icon: 'fa fa-list'
        }
      ]
    },
    {
      divider: true
    },
    {
      name: 'Setting',
      url: '/#',
      icon: 'fa fa-cogs',
      children: [
        {
          name: 'Notification',
          url: '/notification',
          icon: 'fa fa-tint'
        },
        {
          name: 'Folders',
          url: '/folders',
          icon: 'fa fa-tint'
        },
        {
          name: 'Other',
          url: '/#',
          icon: 'fa fa-pencil',
          children: [
            {
              name: 'Export to PRV',
              url: '/other',
              icon: 'fa fa-folder'
            }
          ]
        }
      ]
    }
  ],
  items_analyst: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'fa fa-dashboard',
      badge: {
        variant: 'primary'
      }
    },
    {
      name: 'Reports',
      url: '/#',
      icon: 'fa fa-bar-chart',
      children: [
        {
          name: 'Reports',
          url: '/reports',
          icon: 'fa fa-bar-chart'
        },
        {
          name: 'Monthly Report',
          url: '/monthly_report',
          icon: 'fa fa-bar-chart'
        }
      ]
    },
    {
      name: 'Hauls',
      url: '/#',
      icon: 'fa fa-rocket',
      children: [
        {
          name: 'All Hauls',
          url: '/hauls',
          icon: 'fa fa-rocket'
        },
        {
          name: 'Duplicate Hauls',
          url: '/duplicated_hauls',
          icon: 'fa fa-rocket'
        }
      ]
    },
    {
      name: 'Request Hauls',
      url: '/request_hauls',
      icon: 'fa fa-rocket'
    },
    {
      name: 'Nominations',
      url: '/targets',
      icon: 'fa fa-bullseye'
    },
    {
      name: 'Agreements',
      url: '/agreements',
      icon: 'icon-docs'
    },
    {
      name: 'Hauls Without Agreements',
      url: '/agreements_pending',
      icon: 'icon-docs'
    },
    {
      name: 'Locations',
      url: '/#',
      icon: 'icon-location-pin',
      children: [
        {
          name: 'Load and Unload Locations',
          url: '/locations',
          icon: 'icon-location-pin'
        },
        {
          name: 'Operating Areas',
          url: '/operating_areas',
          icon: 'fa fa-map-marker'
        },
        {
          name: 'Terminal Agreements',
          url: '/terminal_agreements',
          icon: 'fa fa-list'
        }
      ]
    },
    {
      divider: true
    },
    {
      name: 'Setting',
      url: '/#',
      icon: 'fa fa-cogs',
      children: [
        {
          name: 'Notification',
          url: '/notification',
          icon: 'fa fa-tint'
        },
        {
          name: 'Other',
          url: '/#',
          icon: 'fa fa-pencil',
          children: [
            {
              name: 'Export to PRV',
              url: '/other',
              icon: 'fa fa-folder'
            }
          ]
        }
      ]
    }
  ],
  items_analyst_ser: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'fa fa-dashboard',
      badge: {
        variant: 'primary'
      }
    },
    {
      name: 'Intraday Report',
      url: '/intraday',
      icon: 'fa fa-dashboard',
    },
    {
      name: 'Reports',
      url: '/#',
      icon: 'fa fa-bar-chart',
      children: [
        {
          name: 'Reports',
          url: '/reports',
          icon: 'fa fa-bar-chart'
        },
        {
          name: 'Monthly Report',
          url: '/monthly_report',
          icon: 'fa fa-bar-chart'
        }
      ]
    },
    {
      name: 'Hauls',
      url: '/#',
      icon: 'fa fa-rocket',
      children: [
        {
          name: 'All Hauls',
          url: '/hauls',
          icon: 'fa fa-rocket'
        },
        {
          name: 'Duplicate Hauls',
          url: '/duplicated_hauls',
          icon: 'fa fa-rocket'
        }
      ]
    },
    {
      name: 'Request Hauls',
      url: '/request_hauls',
      icon: 'fa fa-rocket'
    },
    {
      name: 'Nominations',
      url: '/targets',
      icon: 'fa fa-bullseye'
    },
    {
      name: 'Agreements',
      url: '/agreements',
      icon: 'icon-docs'
    },
    {
      name: 'Hauls Without Agreements',
      url: '/agreements_pending',
      icon: 'icon-docs'
    },
    {
      name: 'Locations',
      url: '/#',
      icon: 'icon-location-pin',
      children: [
        {
          name: 'Load and Unload Locations',
          url: '/locations',
          icon: 'icon-location-pin'
        },
        {
          name: 'Operating Areas',
          url: '/operating_areas',
          icon: 'fa fa-map-marker'
        },
        {
          name: 'Terminal Agreements',
          url: '/terminal_agreements',
          icon: 'fa fa-list'
        }
      ]
    },
    {
      divider: true
    },
    {
      name: 'Setting',
      url: '/#',
      icon: 'fa fa-cogs',
      children: [
        {
          name: 'Notification',
          url: '/notification',
          icon: 'fa fa-tint'
        },
        {
          name: 'Other',
          url: '/#',
          icon: 'fa fa-pencil',
          children: [
            {
              name: 'Export to PRV',
              url: '/other',
              icon: 'fa fa-folder'
            }
          ]
        }
      ]
    }
  ],
  items_drivers: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'fa fa-dashboard',
      badge: {
        variant: 'primary'
      }
    },
    {
      name: 'Hauls',
      url: '/#',
      icon: 'fa fa-rocket'
    }
  ],
  items_trucking_company_admin: [
    {
      name: 'Dashboard',
      url: '/dash',
      icon: 'fa fa-dashboard',
      badge: {
        variant: 'primary'
      }
    },
    {
      name: 'Monthly Report',
      url: '/monthly_report',
      icon: 'fa fa-bar-chart'
    },
    {
      name: 'Hauls',
      url: '/#',
      icon: 'fa fa-rocket',
      children: [
        {
          name: 'All Hauls',
          url: '/hauls',
          icon: 'fa fa-rocket'
        },
        {
          name: 'Duplicate Hauls',
          url: '/duplicated_hauls',
          icon: 'fa fa-rocket'
        }
      ]
    },
    {
      name: 'Requested Hauls',
      url: '/request_hauls_trucking',
      icon: 'fa fa-rocket',
      badge: {
        text: ''
      }
    },
    {
      name: 'Invoices',
      url: '/#',
      icon: 'fa fa-rocket',
      children: [
        {
          name: 'Trucking Company Invoices',
          url: '/invoices',
          icon: 'fa fa-rocket'
        },
        {
          name: 'Haul invoices',
          url: '/invoices_hauls',
          icon: 'fa fa-rocket'
        }
      ]
    },
    {
      name: 'Users',
      url: '/users',
      icon: 'icon-people'
    },
    {
      name: 'Locations',
      url: '/#',
      icon: 'icon-location-pin',
      children: [
        {
          name: 'Load and Unload Locations',
          url: '/locations',
          icon: 'fa fa-map-marker'
        },
        {
          name: 'Operating Areas',
          url: '/operating_areas',
          icon: 'fa fa-industry'
        }
      ]
    },
    {
      name: 'Trucking',
      url: '/#',
      name: 'Trucks',
      //url: '/trucks',
      icon: 'fa fa-truck',
      children: [
        {
          name: 'Trailers',
          url: '/trucks',
          icon: 'fa fa-truck'
        },
        {
          name: 'Truck Units',
          url: '/trucks_units',
          icon: 'fa fa-truck'
        },
      ]
    },
    {
      divider: true
    },
    {
      name: 'Setting',
      url: '/#',
      icon: 'fa fa-cogs',
      children: [
        {
          name: 'Folders',
          url: '/folders',
          icon: 'fa fa-tint'
        }
      ]
    }
  ],
  items_trucking_company_admin_light: [
    {
      name: 'Hauls',
      url: '/hauls',
      icon: 'fa fa-rocket',
    },
    {
      name: 'Requested Hauls',
      url: '/request_hauls_trucking',
      icon: 'fa fa-rocket',
      badge: {
        text: ''
      }
    }
  ],
  items_operations_manager_admin: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'fa fa-dashboard',
      badge: {
        variant: 'primary'
      }
    },
    {
      name: 'Reports',
      url: '/#',
      icon: 'fa fa-bar-chart',
      children: [
        {
          name: 'Reports',
          url: '/reports',
          icon: 'fa fa-bar-chart'
        },
        {
          name: 'Monthly Report',
          url: '/monthly_report',
          icon: 'fa fa-bar-chart'
        },
        {
          name: 'Discrepancy Report',
          url: '/discrepancy_report',
          icon: 'fa fa-rocket'
        },
        {
          name: 'Tickets Missing Hauls',
          url: '/receipts_wo_hauls',
          icon: 'fa fa-rocket'
        }
      ]
    },
    {
      name: 'All Hauls',
      url: '/hauls',
      icon: 'fa fa-rocket'
    },
    {
      name: 'Trucking',
      url: '/trucking_companies',
      icon: 'fa fa-truck'
    },
    {
      name: 'Users',
      url: '/users',
      icon: 'icon-people'
    },
    {
      name: 'Locations',
      url: '/#',
      icon: 'icon-location-pin',
      children: [
        {
          name: 'Load and Unload Locations',
          url: '/locations',
          icon: 'fa fa-map-marker'
        },
        {
          name: 'Operating Areas',
          url: '/operating_areas',
          icon: 'fa fa-industry'
        }
      ]
    }
  ],
  items_trucking_operational_manager: [
    {
      name: 'Dashboard',
      url: '/dash',
      icon: 'fa fa-dashboard',
      badge: {
        variant: 'primary'
      }
    },
    {
      name: 'Monthly Report',
      url: '/monthly_report',
      icon: 'fa fa-bar-chart'
    },
    {
      name: 'Hauls',
      url: '/#',
      icon: 'fa fa-rocket',
      children: [
        {
          name: 'All Hauls',
          url: '/hauls',
          icon: 'fa fa-rocket'
        },
        {
          name: 'Duplicate Hauls',
          url: '/duplicated_hauls',
          icon: 'fa fa-rocket'
        }
      ]
    },
    {
      name: 'Requested Hauls',
      url: '/request_hauls_trucking',
      icon: 'fa fa-rocket',
      badge: {
        text: ''
      }
    },
    {
      name: 'Invoices',
      url: '/#',
      icon: 'fa fa-rocket',
      children: [
        {
          name: 'Trucking Company Invoices',
          url: '/invoices',
          icon: 'fa fa-rocket'
        },
        {
          name: 'Haul invoices',
          url: '/invoices_hauls',
          icon: 'fa fa-rocket'
        }
      ]
    },
    {
      name: 'Users',
      url: '/users',
      icon: 'icon-people'
    },
    {
      name: 'Locations',
      url: '/#',
      icon: 'icon-location-pin',
      children: [
        {
          name: 'Load and Unload Locations',
          url: '/locations',
          icon: 'fa fa-map-marker'
        },
        {
          name: 'Operating Areas',
          url: '/operating_areas',
          icon: 'fa fa-industry'
        }
      ]
    },
    {
      name: 'Trucking',
      url: '/#',
      //name: 'Trucks',
      //url: '/trucks',
      icon: 'fa fa-truck',
      children: [
        {
         name: 'Trailers',
          url: '/trucks',
          icon: 'fa fa-truck'
        },
        {
          name: 'Truck Units',
          url: '/trucks_units',
          icon: 'fa fa-truck'
        },
      ]
    },
    {
      divider: true
    },
    {
      name: 'Setting',
      url: '/#',
      icon: 'fa fa-cogs',
      children: [
        {
          name: 'Folders',
          url: '/folders',
          icon: 'fa fa-tint'
        }
      ]
    }
  ],
  items_marketing_accountant: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'fa fa-dashboard',
      badge: {
        variant: 'primary'
      }
    },
    {
      name: 'Reports',
      url: '/#',
      icon: 'fa fa-bar-chart',
      children: [
        {
          name: 'Reports',
          url: '/reports',
          icon: 'fa fa-bar-chart'
        },
        {
          name: 'Monthly Report',
          url: '/monthly_report',
          icon: 'fa fa-bar-chart'
        }
      ]
    },
    {
      name: 'Hauls',
      url: '/#',
      icon: 'fa fa-rocket',
      children: [
        {
          name: 'All Hauls',
          url: '/hauls',
          icon: 'fa fa-rocket'
        },
        {
          name: 'Duplicate Hauls',
          url: '/duplicated_hauls',
          icon: 'fa fa-rocket'
        }
      ]
    },
    {
      name: 'Request Hauls',
      url: '/request_hauls',
      icon: 'fa fa-rocket'
    },
    {
      name: 'Nominations',
      url: '/targets',
      icon: 'fa fa-bullseye'
    },
    {
      name: 'Invoices',
      url: '/#',
      icon: 'fa fa-rocket',
      children: [
        {
          name: 'Invoice Customer',
          url: '/invoice_customers',
          icon: 'fa fa-rocket'
        },
        {
          name: 'Invoice Contract',
          url: '/invoice_contracts',
          icon: 'fa fa-rocket'
        },
        {
          name: 'Invoice Adjust',
          url: '/invoice_adjusts',
          icon: 'fa fa-rocket'
        },
        {
          name: 'Invoice Price',
          url: '/invoice_prices',
          icon: 'fa fa-rocket'
        }
      ]
    },
    {
      name: 'Agreements',
      url: '/agreements',
      icon: 'icon-docs'
    },
    {
      name: 'Hauls Without Agreements',
      url: '/agreements_pending',
      icon: 'icon-docs'
    },
    {
      name: 'Locations',
      url: '/#',
      icon: 'icon-location-pin',
      children: [
        {
          name: 'Load and Unload Locations',
          url: '/locations',
          icon: 'icon-location-pin'
        },
        {
          name: 'Operating Areas',
          url: '/operating_areas',
          icon: 'fa fa-map-marker'
        },
        {
          name: 'Terminal Agreements',
          url: '/terminal_agreements',
          icon: 'fa fa-list'
        }
      ]
    },
    {
      divider: true
    },
    {
      name: 'Setting',
      url: '/#',
      icon: 'fa fa-cogs',
      children: [
        {
          name: 'Notification',
          url: '/notification',
          icon: 'fa fa-tint'
        },
        {
          name: 'Other',
          url: '/#',
          icon: 'fa fa-pencil',
          children: [
            {
              name: 'Export to PRV',
              url: '/other',
              icon: 'fa fa-folder'
            }
          ]
        }
      ]
    }
  ],
}



// WEBPACK FOOTER //
// ./src/_nav.js